<template>
  <h1>{{ t('pages.terms.title') }}</h1>
</template>

<script setup lang="ts">
const { t } = useI18n()
definePageMeta({
  layout: 'full-width'
})
</script>